import { getEnv } from '@/common/utils/common'

/**
 * partner url pattern prefix (dev, qa)
 * pattern / replacement both are optional
 * ex) (url) wwww. -> dev. / qa.
 * ex) (url, 'bill', 'bill_prefix_') bill -> billdev ->
 * @param url
 * @param pattern
 * @param replacement
 * @returns {string}
 */
export const getPartnersPrefix = (url = '', pattern = '', replacement = '') => {
  const prefix = getEnv()
  const regExp = pattern ? new RegExp(pattern, 'gi') : /www./gi

  if (!url) {
    return ''
  }

  if (prefix === 'prd') {
    return url
  }

  return url?.replace(
    regExp,
    replacement ? replacement.replace('_prefix_', prefix) : `${prefix}.`,
  )
}
